<template>
  <Modal ref="modal" title="Cadastrar Novo Veículo">
    <div class="novo-veiculo-container">
      <form @submit.prevent="handleSubmit">
        <div class="inputs">
          <Input legend="Placa" placeholder="Insira a placa do veículo" :modelValue="placa"
            @update:modelValue="$event => placa = $event.toUpperCase()" :disabled="loading" required />

          <Select legend="Categoria" placeholder="Selecione a categoria" :options="categorias"
            :modelValue="categoria" @update:modelValue="$event => categoria = $event" :disabled="loading" required />
        </div>

        <div class="actions">
          <Button @handle:click="close" text="Cancelar" color="danger" type="button" :disabled="loading" />
          <Button text="Cadastrar" color="primary" type="submit" :loading="loading" />
        </div>
      </form>
    </div>
  </Modal>
</template>

<script>
import Modal from '../core/Modal'
import Button from '../core/Button'
import Input from '../core/Input'
import Select from '../core/Select'
import urlApi from '../../router/urlApi'

export default {
  name: 'NovoVeiculoModal',
  components: {
    Modal,
    Button,
    Input,
    Select,
  },
  data() {
    return {
      placa: '',
      categoria: null,
      categorias: [],
      loading: false,
    }
  },
  methods: {
    async open() {
      this.resetForm()
      await this.fetchCategorias()
      this.$refs.modal.open()
    },
    close() {
      this.$refs.modal.close()
    },
    resetForm() {
      this.placa = ''
      this.categoria = null
    },
    async fetchCategorias() {
      this.loading = true
      
      await this.$http.get(`${urlApi}/categorias`)
        .then(response => {
          this.categorias = response.body.dados.map(categoria => ({ 
            value: categoria.id_categoria_cnh, 
            text: categoria.categoria_cnh 
          }))
        })
        .catch(err => {
          this.toast('Erro ao listar categorias.')
        })
        .finally(() => {
          this.loading = false
        })
    },
    async handleSubmit() {
      if (!this.placa || !this.categoria) {
        this.toast('Preencha todos os campos.')
        return
      }
        const placaPadrao = /^[A-Z]{3}\d{4}$/i
        const placaMercosul = /^[A-Z]{3}[0-9][A-Z][0-9]{2}$/i

        if (!placaPadrao.test(this.placa) && !placaMercosul.test(this.placa)) {
            this.toast('Formato de placa inválido. Use o padrão ABC1234 ou ABC1D23.')
            return
        }
      this.loading = true
      
      const params = {
        placa: this.placa,
        id_categoria_cnh: this.categoria,
      }
      
      await this.$http.post(`${urlApi}/veiculos`, params)
        .then(response => {
          this.toast('Veículo cadastrado com sucesso!')
          this.close()
          this.$emit('veiculoCadastrado')
        })
        .catch(err => {
          if (err.body && err.body.mensagem) {
            this.toast(err.body.mensagem)
          } else {
            this.toast('Erro ao cadastrar veículo.')
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    toast(text) {
      this.$toasted.show(text, {
        position: 'top-right',
        duration: 5000,
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.novo-veiculo-container {
  width: 30rem;
  max-width: 100%;
  
  form {
    display: flex;
    flex-direction: column;
    gap: 2rem;
    
    .inputs {
      display: flex;
      flex-direction: column;
      gap: 1rem;
    }
    
    .actions {
      align-self: flex-end;
      display: flex;
      gap: 1rem;
    }
  }
}
</style>
